import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox flex-col" }
const _hoisted_3 = { class: "flex mb-4" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon-upload" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "title"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon-downlaod" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["disabled", "title"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "icon-pdf" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled", "title"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "icon-versenden" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["disabled", "title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "icon-liste_tagebuch" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "ml-auto" }
const _hoisted_26 = { class: "text-center" }

import FilterService from "@/utilities/services/FilterService";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {LocationInfo} from "@/models/location/LocationInfo";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {Menu, Store, StringHelper} from "@bryntum/grid";
import {onBeforeUnmount, onMounted, reactive, ref, toRaw} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import dialog from "@/dialog";
import GridInputFilter from "@/components/GridInputFilter";
import {DisdiStateType, ErrorLocationType, PdfExportActionEnum, PopupType, TableType} from "@/utilities/enums/Enums";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {GeneralResponse} from "@/models/api/Responses";
import {LocationCsvExport} from "@/models/CsvExportModels";
import Error from "@/components/Error";
import exportFromJSON from "export-from-json";
import {$t} from "@/utilities/i18n/config";
import {useI18n} from "vue-i18n";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage, permissionColumn} from "@/AppConfig";
import {PermissionService} from "@/utilities/services/PermissionService";
import {LocationService} from "@/utilities/services/entities/LocationService";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import router from "@/router";
import {LocationDisdiInfo} from "@/models/location/LocationDisdiInfo";



export default /*#__PURE__*/_defineComponent({
  __name: 'Location',
  setup(__props) {

const { t } = useI18n();
const locationService = new LocationService();
const permissionService = new PermissionService();
const disablePdfExport = ref(false);

const gridStore = new Store();
const globalStore = useGlobalStore();

let selectedLocations = ref([]);
const disdiIsOn = ref<boolean>(false);

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedLocations.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t('global.delete'))
      .cancelText(t('global.cancel'))
      .confirm(t('locations.confirmDeletionMulti', {count:selectedLocations.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const loc of selectedLocations.value){
      const resp = await locationService.deleteLocation(loc.id);

      if(resp === null || resp === undefined || resp?.statusCode !== 0){
        ErrorHandler.handleError(resp, ErrorLocationType.table);
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:loc.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess(t("global.deleted"));
  }
};

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const newLocation = async () => {
  const location = new LocationInfo();

  // call API-Service and set locationIdentifier from next free Id
  const nextIdResp = await locationService.getNextFreeLocationId();
  if(nextIdResp === null || nextIdResp === undefined || nextIdResp?.statusCode !== 0){
    ErrorHandler.handleError(nextIdResp, ErrorLocationType.table);
    return;
  }

  location.secondaryId = nextIdResp.secondaryId;

  globalStore.openPopup({
    data:location,
    action:addOrUpdateLocation,
    resetButton:false,
    title:$t("popups.locationEditor.title.new"),
    type:PopupType.locationEditor}
  );
};

const openMassDisdiPopoup = async()=>{
  globalStore.openPopup({
    data: [],
    action: massEditDisdi,
    resetButton: false,
    title: $t("popups.locationDisdiEditor.title"),
    type: PopupType.locationDisdiEditor,
  }, true);
}

const massEditDisdi = async()=>{
  // need to make flat copy of proxy object to send correct json format to backend
  const newDisdiInfo = new Array<LocationDisdiInfo>();
  for (const keyValueArray of Object.entries(globalStore.modal.contentObject)){
    newDisdiInfo.push(toRaw(keyValueArray[1]) as LocationDisdiInfo)
  }

  const success = await locationService.putSetLocationDisdiSettings(newDisdiInfo, ErrorLocationType.popup);

  if(!success) return;

  await setGridData();

  globalStore.closeModal();
  globalStore.showSuccess(t('global.saved'));
}

const exportCSV = () => {
  let data = selectedLocations.value?.length > 0 ? selectedLocations.value : gridStore.records;

  // remove unnecessary properties from csv
  data = data.map((item)=> new LocationCsvExport(item.data ?? item));

  const fileName = t('locations.exportFilename');
  const exportType =  exportFromJSON.types.csv;

  exportFromJSON({
    data:data,
    fileName:fileName,
    exportType:exportType,
  });
};

const getPdf = async (type:PdfExportActionEnum) => {
  if(type === PdfExportActionEnum.download) {
    disablePdfExport.value = true;
  }

  const locationIds = selectedLocations.value?.length > 0
      ? selectedLocations.value.map(sl => sl.id)
      : gridStore.data.map(l => l.id);

  const resp = await locationService.postExportLocationPdf(type, locationIds);
  if (resp === null || resp === undefined || resp.statusCode !== 0){
    ErrorHandler.handleError(resp as GeneralResponse, ErrorLocationType.table);
    disablePdfExport.value = false;
    return;
  }

  globalStore.showSuccess(type === PdfExportActionEnum.download ? $t('locations.willDownload') : $t('locations.willBeSend'));

  if(type === PdfExportActionEnum.download) {
    //@ts-expect-error
    const buffer = new Buffer(resp.pdfContentResult?.fileContents, "base64");
    const blob = new Blob([buffer], {type: resp.pdfContentResult?.contentType});
    const link = document.createElement("a");

    link.href = window.URL.createObjectURL(blob);
    link.download = resp.pdfContentResult?.fileDownloadName as string;
    link.click();
    link.remove();
    disablePdfExport.value = false;
  }
};

const csvImport = async () => {
  globalStore.openPopup({
    data: {},
    action: uploadCsvFile,
    resetButton:false,
    title: $t("popups.locationCsvImport.title"),
    type: PopupType.csvImportPopup
  });
}

const uploadCsvFile = async () => {
  const file = globalStore.uploadedFile;

  if(NullOrUndefinedHelper(file)) return;

  // @ts-expect-error
  const uploadResp = await locationService.postImportLocations(file);
  globalStore.uploadedFile = null;
  if (uploadResp === null || uploadResp === undefined || uploadResp.statusCode !== 0){
    ErrorHandler.handleError(uploadResp as GeneralResponse, ErrorLocationType.popup);
    return;
  }

  // update globalStore data and filters etc
  await setGridData();

  globalStore.closeModal();
  globalStore.showSuccess(t('global.saved'));
};

const updateLocationEntry = ()=>{
  const loc = globalStore.modal.contentObject;

  console.log("loc update", loc);

  // in case on an update bryntum automatically replaces the entry with the same ID
  gridStore.add(loc);

  globalStore.closeModal();
}

const addOrUpdateLocation = async () => {
  const loc = globalStore.modal.contentObject as LocationInfo;

  loc.registrationRadius = typeof loc.registrationRadius === "string"
      ? +(loc.registrationRadius as string).replace(",",".")
      : loc.registrationRadius;

  const locResp = await locationService.addOrUpdateLocation(loc);
  if (locResp === null || locResp === undefined || locResp.statusCode !== 0){
    ErrorHandler.handleError(locResp as GeneralResponse, ErrorLocationType.popup);
    return;
  }

  // if response had an id-prop it was an add so copy the generated id
  if (locResp.id !== undefined) loc.id = locResp.id;
  // fix selection when it was an update -> replace old value in selected-array
  else if(selectedLocations.value.some(el => el.id === loc.id)) {
    selectedLocations.value = selectedLocations.value.filter(el => el.id !== loc.id);
    selectedLocations.value.push(loc);
  }

  // in case on an update bryntum automatically replaces the entry with the same ID
  gridStore.add(loc);
  // reapply sorting
  gridStore.sort(gridStore.sorters);
  // reapply filtering
  gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.location])
  });

  globalStore.closeModal();
  globalStore.showSuccess(t('global.saved'));
}


const grid = ref(null);
const useGridConfig = {
  relayStoreEvents: true, // triggers important event (globalStore-/data-related) to get bryntum stores !
  headerMenuFeature: false,
  sort: true,
  cellEditFeature: false,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
		hideOnDelegateChange: true,
  },
  filter: {
    prioritizeColumns : true
  },
  enableTextSelection: true,
  selectionMode: {
    cell: false,
    row: true,
    checkbox: checkboxColumnConfig,
    showCheckAll: true,
    deselectFilteredOutRecords: true,
  },
  columns : {
    data: [
      {
        id: 'secondaryId',
        text : t('locations.grid.secId'),
        field : 'secondaryId',
        width: 72,
        filterable: false,
        hideable: true
      },
      {
        id: 'name',
        text : t('locations.grid.name'),
        field : 'name',
        flex: 1,
        filterable: false,
        hideable: false
      },
      {
        id: 'infoButton',
        field: 'infoButton',
        text: t('registrationReports.grid.info'),
        hidden: permissionService.userHasPermission("Location.HideInfoColumn"), // hide for Datenpfleger 4 role
        width: 36,
        sortable: false,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-info'></span></div>`;
        },
      },
      {
        id: 'group2Name',
        text : t('locations.grid.group2Name'),
        field : 'group2Name',
        flex: 1,
        filterable: false,
        hideable: true,
      },
      {
        id: 'group1Name',
        text : t('locations.grid.group1Name'),
        field : 'group1Name',
        flex: 1,
        filterable: false,
        hideable: true,
      },
      {
        id: 'controlCenterName',
        text : t('locations.grid.controlCenterName'),
        field : 'controlCenterName',
        flex: 1,
        filterable: false,
        hideable: true,
      },
      {
        id: 'customAdditionalInformation',
        text : t('locations.grid.customAdditionalInformation'),
        field : 'customAdditionalInformation',
        flex: 1,
        filterable: false,
        hideable: true,
      },
			{ id: 'email',
				text : t('locations.grid.email'),
				field : 'email',
				flex: 1,
				filterable: false,
				hideable: false,
			},
			{
        id: 'safetyInstructions',
        text: '',
        field: 'safetyInstructions',
        htmlEncode: false,
				sortable: false,
        type: 'template',
        width: 36,
        filterable: false,
        hideable: true,
        tooltipRenderer: ({ record }:any) =>{
          if(!record.safetyInstructions?.some(()=>true)) return "";

          const listString = record.data.safetyInstructions?.map((si:any) =>"<li>"+si.name+"</li>").join("");

          return StringHelper.xss`<strong>${t('locationsReports.securityInformations')}:</strong><br/><ol class='securityLists'>`+listString+`</ol>`;
        },
        template: ({ record }) => {
          if(!record.safetyInstructions?.some(()=>true)) return "";
          return `<div class='gridTooltipButton'><span class='icon-sicherheitshinweis'></span></div>`;
        },
      },
      {
        id: 'coupling',
        text: '',
				sortable: false,
        field: 'coupledSystemsName',
        type: 'template',
        template: ({record}:any) => {
          if(!record.couplingEnabled) return "";
          if(!record.coupledSystemsName?.some(()=>true))
            return "<div class='gridTooltipButton'><span class=\"icon-entkopplung\"></span></div>";

          return "<div class='gridTooltipButton'><span class=\"icon-kopplung\"></span></div>";
        },
        width: 36,
        tooltipRenderer: ({ record }:any) =>{
          if(!record.couplingEnabled) return "";
          if(!record.coupledSystemsName?.some(()=>true))
            return t('locations.grid.noCoupledSystems');

          return "Systeme:<br/>" + record.coupledSystemsName.join("<br/>");
        },
        filterable: false,
        hideable: true,
      },
      {
        id:'hasDisdi',
        field:'hasDisdi',
        text	: "",
        width   : 36,
        type	: 'template',
        align: "center",
        hidden: !permissionService.userHasPermission("Disdi.Read"),
        resizable: false,
        filterable: false,
        template : ({record}:any)=> {
          return record.data.hasDisdi && record.data.disdiCount > 0
              ? `<div class='gridRowButton'><span class='icon-liste_tagebuch'></span></div>`
              : record.data.hasDisdi && record.data.disdiCount === 0
                  ? `<div class='gridRowButtonDisabled'><span class='icon-liste_tagebuch'></span></div>`
                  : "";
        }
      },
      {
        id: 'menu',
        text  : '',
        width   : 36,
        type  : 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [
          {
            type   : 'button',
            width: 36,
            icon   : 'icon-kontext_horizontal',
            onAction : ({ source: btn }:any) => {
              const menu = menuFactory(btn.cellInfo.record.data);
              menu.alignTo({ target: btn })
              menu.show();
            }
          }
        ]
      }
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.location], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0].data === undefined) return;
      selectedLocations.value = selectedLocations.value.concat(event.selected.map(lr => lr.data))
      selectedLocations.value = selectedLocations.value.filter(l => !event.deselected.map(lr => lr.data).some(lr => l?.id === lr?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    async cellClick({column, record}:any) {
      if(column.data.field === 'infoButton'){
        globalStore.openPopup({
          data:record.data,
          action: () => {},
          resetButton:false,
          title:$t("locationsReports.locationDetails"),
          type:PopupType.locationReportsDetailsPopup
        }, true);
      }

      if(column.data.field === 'hasDisdi'){

        const rd = record.data;
        if (!rd.hasDisdi || (rd.hasDisdi && rd.disdiCount === 0)) return;

          globalStore.setDisdiContext({...rd,
              locationId: rd.secondaryId,
              lastRegisteredLocationDate: '',
              locationName: rd.name}
          );  
        await router.push(`disdi/${TableType[TableType.location]}/${record.secondaryId}`);
      }
    },
  },
  store: gridStore,
  height: currentWindowHeight,
};
const gridConfig = reactive(useGridConfig);


const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items   : [
      {
        text   : t('global.edit'),
        icon : 'icon-editieren',
        hidden: !permissionService.userHasPermission("Location.Edit"),
        cls : 'b-separator',
        onItem : async ({ menu }) => {
          const record = menu.record;
          const location = await locationService.getLocation(record.id, ErrorLocationType.table);


          if(NullOrUndefinedHelper(location)) return;

          // take coupling info into popup, since it is not returned by ById
          //@ts-expect-error
          location.coupledSystemsName = record.coupledSystemsName;

          // convert to list of indexes for Popup MultiSelect
          // @ts-expect-error
          location.safetyInstructions = location?.safetyInstructions.map(si => si.id);

          globalStore.openPopup({
            data:location,
            action:addOrUpdateLocation,
            resetButton:false,
            title:$t("popups.locationEditor.title.edit"),
            type:PopupType.locationEditor
          });
        },
        weight : 200
      },
      {
        text   : t('global.delete'),
        cls : 'b-separator',
        icon : 'icon-loeschen',
        hidden: !permissionService.userHasPermission("Location.Delete"),
        onItem : async ({ menu }) => {
          const answer = await dialog
              .okText(t('global.delete'))
              .cancelText(t('global.cancel'))
              .confirm(t('locations.confirmDeletionSingle', {name:menu.record.name}));

          if (answer) {
            const resp = await locationService.deleteLocation(menu.record.id);

            if(resp === null || resp === undefined || resp?.statusCode !== 0){
              ErrorHandler.handleError(resp, ErrorLocationType.table);
              return;
            }

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            globalStore.showSuccess(t("global.deleted"));
          }
        },
        weight : 300
      },
      {
        text   : t('locations.changeCoupling'),
        disabled: !record.couplingEnabled,
        cls : 'b-separator',
        icon : 'icon-kopplung',
        onItem : ({ menu }) => {
          const record = menu.record;
          globalStore.openPopup({
            data:record,
            action:updateLocationEntry,
            resetButton:false,
            title:$t("popups.locationCoupling.title"),
            type:PopupType.locationCouplingPopup
          }, true);
        },
        weight : 900
      }
    ]})

  menu.setRecord(record);

  return menu;
};

const setGridData = async ()=>{
  const locations = await locationService.getLocations("display", ErrorLocationType.table);

  gridStore.setStoreData(locations);

  // apply filters
  gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.location])
  });

  // apply hidden cols
  for(const c of grid.value.instance.value.columns.storage.values){
    const needsHiding = globalStore.userPreferences.userHiddenColumns
        .some((thc) => thc.attributeName === c.data.field && thc.tableName === TableType[TableType.location]);

    if(needsHiding && !c.hidden) {
      c.hide();
    }
    else if(!needsHiding && c.hidden && !permissionColumn.includes(c.id)) {
      c.show();
    }
  }

  globalStore.reorderColumns(TableType[TableType.location]);

  globalStore.closeModal();
}

const setDisdiColumVisibility = async() =>{
  disdiIsOn.value = globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI;

  if(!disdiIsOn.value){
    const hasDisdiCol = grid.value.instance.value.columns.getById("hasDisdi");
    hasDisdiCol.hidden = true;
  }
}

onMounted(async () => {
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  // because these are refs they dont survive page-reloads so set them anytime the grid loads
  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  // start spinner
  globalStore.gridDataIsLoading = true;
  await setGridData();
  await setDisdiColumVisibility();
  // stop spinner
  globalStore.gridDataIsLoading = false;
});

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)("locations.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(Error), {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "primary mr-2",
            onClick: newLocation,
            title: _unref(t)('locations.newLocation')
          }, _hoisted_6, 8, _hoisted_4)), [
            [_directive_permission, 'Location.Create']
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "primary mr-2",
            onClick: csvImport,
            title: _unref(t)('global.importCsv')
          }, _hoisted_9, 8, _hoisted_7)), [
            [_directive_permission, 'Location.CSV.Import']
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            disabled: !_unref(selectedLocations).some(()=>true),
            class: "primary mr-2",
            onClick: exportCSV,
            title: _unref(t)('global.exportCsv')
          }, _hoisted_12, 8, _hoisted_10)), [
            [_directive_permission, 'Location.CSV.Export']
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "primary mr-2",
            disabled: !_unref(selectedLocations).some(()=>true) || disablePdfExport.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (getPdf(_unref(PdfExportActionEnum).download))),
            title: _unref(t)('global.downloadPdf')
          }, _hoisted_15, 8, _hoisted_13)), [
            [_directive_permission, 'Location.Read']
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "primary mr-2",
            disabled: !_unref(selectedLocations).some(()=>true),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getPdf(_unref(PdfExportActionEnum).email))),
            title: _unref(t)('global.downloadPdfMail')
          }, _hoisted_18, 8, _hoisted_16)), [
            [_directive_permission, 'Location.Read']
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "primary mr-2",
            disabled: !_unref(selectedLocations).some(()=>true),
            onClick: deleteSelection,
            title: _unref(t)('global.delete')
          }, _hoisted_21, 8, _hoisted_19)), [
            [_directive_permission, 'Location.Delete']
          ]),
          (disdiIsOn.value)
            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "primary mr-2",
                onClick: openMassDisdiPopoup,
                title: _unref(t)('locations.massDisdi')
              }, _hoisted_24, 8, _hoisted_22)), [
                [_directive_permission, 'Disdi.LocationPropertyEdit']
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_unref(GridInputFilter), {
              gridStore: _unref(gridStore),
              popupType: _unref(PopupType).locationFilterPopup
            }, null, 8, ["gridStore", "popupType"])
          ])
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig), null, 16)
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_26, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(globalStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})